import {gsap} from "gsap";
import moment from "moment";

const PricesTabTools = {

    init() {
        this.el = $('[page="prices"] section.TabTools');

        if (!this.el.length) {
            return;
        }

        this.allowEditButton = this.el.find("button.allow-edit");
        this.saveButton = this.el.find("button.save");
        this.navButton = this.el.find('[component="NavButton"]');
        this.nav = this.el.find('nav');
        this.alert = this.el.find('.alert');

        this.dateFrom = this.el.find('[name="date_from"]');

        this.bind();
    },

    bind() {
        this.navButton.unbind('click').click((evt) => {
            const el = $(evt.currentTarget);

            if (!el.is('.open')) {
                this.open();
            } else {
                this.close();
            }
        });

        this.bindAdmin();
    },

    bindAdmin() {
        if (!Prices.isAdmin) {
            return;
        }

        this.saveButton.on("click", Prices.save);

        this.allowEditButton.on("click", function () {
            Prices.setEditable(!Prices.editable);

            if (!Prices.editable) {
                Prices.reset();
            }
        });

        this.dateFrom.closest('.input').attr('from', moment().format('DD.MM.YYYY'))

        this.dateFrom.on('change', (event) => {
            const currentUrl = window.location.href;
            const newDate = $(event.currentTarget).val();

            // Remove existing date_from parameter from the URL, if it exists
            const urlWithoutDateFrom = currentUrl.replace(/(\?|&)date_from=[^&]*(&|$)/, '$2');

            // Construct the new URL with the updated date_from parameter
            const separator = urlWithoutDateFrom.includes('?') ? '&' : '?';
            const updatedUrl = urlWithoutDateFrom + separator + 'date_from=' + newDate;

            // Redirect to the updated URL
            window.location.href = updatedUrl.replace('#?', '?');
        });
    },

    open() {
        this.navButton.removeClass('closing').addClass('open');
        gsap.set(this.nav, {height: "auto", padding: 12});
        gsap.from(this.nav, {height: 0, padding: 0});
    },

    close() {
        this.navButton.removeClass('open').addClass('closing');
        gsap.to(this.nav, {height: 0, padding: 0, clearProps: true});
    },

    showAlert() {
        this.alert.removeClass("visible").addClass("visible");

        setTimeout(() => {
            this.alert.removeClass("visible");
        }, 2500);
    }
}

export default PricesTabTools;